import * as React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import {TextField, Select} from '@mui/material';
import Box from '@mui/material/Box';
import {useLoaderData, useNavigate} from "react-router-dom";
import api from "../services/api";
import {useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";

export default function Debriefing() {
    const navigate = useNavigate()
    const { game, survey } = useLoaderData();
    const [loading, setLoading] = useState(false)
    const [userAnswers, setUserAnswers] = useState([]);
    const [goldAnswers, setGoldAnswers] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const onAnswerGold = (character, value) => {
        const ga = [...goldAnswers.filter(gold => gold.character_id !== character.id)]
        if (value === '' || !value) {
            value = 0
        }

        value = value > 100 ? 100 : value
        ga.push({
            character_id: character.id,
            value,
            score: value
        })
        setGoldAnswers(ga);
    }

    const onAnswerValue = (question, value) => {
        const ua = [...userAnswers.filter(answer => answer.question_id !== question.id)]
        let computedValue = parseInt(value)
        let score = 0
        const extra = JSON.parse(question.extra)
        const max = extra?.max
        const ratio = extra?.ratio

        if (!isNaN(computedValue)) {
            computedValue = !!max ? (value <= max ? value : max) : value
            score = !!ratio ? value * ratio : value
        } else {
            computedValue = value
        }

        ua.push({
            question_id: question.id,
            value: computedValue,
            score
        })
        setUserAnswers(ua);
    }

    const onAnswerSelect = (question, value) => {
        const ua = [...userAnswers.filter(answer => answer.question_id !== question.id)]
        const answer = answers(question).find(answer => answer.id === value)

        ua.push({
            question_id: question.id,
            value: answer.id,
            score: answer.score
        })
        setUserAnswers(ua);
    }

    const onSubmit = () => {
        setLoading(true)
        api().answerSurvey(survey.id, {
            game_id: game.id,
            answers: [
                ...goldAnswers,
                ...userAnswers
            ]
        })
            .then(() => navigate('/games/' + game.id + '/score'));
    }

    const answers = (question) => {
        if (question.answers?.length) {
            return question.answers;
        } else {
            return [
                {
                    id: 'Oui',
                    answer: 'Oui',
                    index: 1,
                    score: JSON.parse(question.extra)?.score || 1
                },
                {
                    id: 'Non',
                    answer: 'Non',
                    index: 2,
                    score: 0
                }
            ]
        }
    };

    return (
        <>
            <Box component="form" onSubmit={onSubmit} noValidate sx={{ mt: 1 }} style={{height: "100%", overflow: 'hidden'}}>
                <Typography variant={'h6'} color={'primary'} sx={{ mt: 3 }}>
                    Pièces d'Or
                </Typography>
                <Typography variant={'caption'} color={'text.secondary'}>
                    Renseignez les pièces d'or collectées
                </Typography>
                {game.characters.map(character => <TextField
                    key={'character-' + character.id}
                    type={'number'}
                    onChange={event => onAnswerGold(character, event.target.value)}
                    margin={'dense'}
                    fullWidth
                    value={goldAnswers.find(gold => gold.character_id === character.id)?.value || ''}
                    label={`Pièces collectées par le ${character.role.name}`}
                />)}
                {survey.sections.map(section =>
                    <div key={'section-' + section.id}>
                        <Typography variant={'h6'} color={'primary'} sx={{ mt: 3 }}>
                            {section.name}
                        </Typography>
                        {section.questions.map(question => <div key={'section-question' + question.id}>
                            <Typography variant={'caption'} color={'text.secondary'}>{question.question}</Typography>
                            {question.type === 'value' && <TextField
                                type={'number'}
                                onChange={event => onAnswerValue(question, event.target.value)}
                                margin={'dense'}
                                fullWidth
                                value={userAnswers.find(answer => answer.question_id === question.id)?.value || ''}
                                label={'valeur de ' + (JSON.parse(question.extra)?.min || 0) + ' à ' + (JSON.parse(question.extra)?.max || 10)}
                            />}
                            {question.type === 'select' && <Select
                                fullWidth
                                value={userAnswers.find(answer => answer.question_id === question.id)?.value || ''}
                                onChange={event => onAnswerSelect(question, event.target.value)}
                                id={'question-' + question.id}
                                label={'Répondre'}
                                name={'question-' + question.id}
                            >
                                {answers(question).map(answer =>
                                    <MenuItem key={'answer-' + answer.id} value={answer.id}>{answer.answer}</MenuItem>)}
                            </Select>}
                        </div>)}
                    </div>)}

                <LoadingButton
                    loading={loading}
                    fullWidth
                    onClick={onSubmit}
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Valider les réponse
                </LoadingButton>
            </Box>
        </>
    );
}
